import { controlCornerRadius, designUnit, strokeWidth } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
import { forcedColorsStylesheetBehavior } from '@microsoft/fast-foundation';
import { SystemColors } from '@microsoft/fast-web-utilities';
/** @internal */
export const foundationFormStyles = css `
  :host {
    border: calc(${strokeWidth} * 1px) solid transparent;
    margin: 0;
    border-radius: calc(${controlCornerRadius} * 1px);
    padding: calc(${designUnit} * 1px);
    min-width: 64px;
  }

  .form-controls {
    display: grid;
    grid-gap: calc(${designUnit} * 1px);
    grid-column-gap: calc(${designUnit} * 7px);
    grid-template-columns: repeat(2, 1fr);
  }

  .form-group {
    display: flex;
    flex-direction: column;
  }

  .required::after {
    content: ' *';
    color: #f00;
  }

  .label {
    font-size: calc(${designUnit} * 1px + 0.7vmin);
  }

  .actions {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
    padding: calc(${designUnit} * 2px);
    gap: 10px;
  }

  .error {
    border-bottom: 2px solid red;
  }

  .submit-button {
    width: 70px;
    margin: 0;
  }
`.withBehaviors(forcedColorsStylesheetBehavior(css `
    :host {
      background: ${SystemColors.Canvas};
      border-color: ${SystemColors.CanvasText};
    }
  `));
